/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StaffMemberRouteLinkItem from './StaffMemberRouteLinkItem';
import OtherContactsIcon from 'icons/OtherContactsIcon';

const messages = defineMessages({
  title: {id: 'navigation.other-contacts'},
});

const OtherContactsItem = () => (
  <StaffMemberRouteLinkItem
    iconBefore={OtherContactsIcon}
    route="midas/staff-member/other-contacts"
    title={messages.title}
  />
);

export default OtherContactsItem;
